import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";

export interface MutateUserDisableParams {
  id: number;
}

export const mutateUserDisable = async (values: MutateUserDisableParams) => {
  const { id } = values;
  const response = await makeMutation(ApiEndpoints.userDisable(id), null, true);
  return { success: response.success };
};
